import type { UseCase } from '@contexts/shared/application';
import { enumValueObject, stringValueObject, uuidValueObject } from '@contexts/shared/domain';
import {
	type Role,
	RoleOptions,
	type User,
	type UserCore,
	type UserRepository
} from '@contexts/users/domain';

import { type Language, LanguageOptions } from '../../domain/models/language';

export type CreateUserUseCase = UseCase<UserCore, User>;

export function createUserBuilder(userRepository: UserRepository): CreateUserUseCase {
	return async function createUser(user: UserCore): Promise<User> {
		const id = uuidValueObject().validate('id', user.id);
		const firstName = stringValueObject().validate('firstName', user.firstName);
		const lastName = stringValueObject().validate('lastName', user.lastName);
		const email = stringValueObject().validate('email', user.email);
		const role = enumValueObject<RoleOptions, Role>()
			.setEnum(RoleOptions)
			.validate('role', user.role);
		const delegationId =
			user.delegationId && uuidValueObject().validateOptional('id', user.delegationId);
		const language = enumValueObject<LanguageOptions, Language>()
			.setEnum(LanguageOptions)
			.validate('language', user.language);
		const phone = stringValueObject().validate('phone', user.phone);

		const newUser: UserCore = {
			id,
			firstName,
			lastName,
			email,
			role,
			delegationId,
			language,
			phone
		};
		return userRepository.create(newUser);
	};
}
